import script from "./MiqaatFiltersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MiqaatFiltersDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__